module.exports = __webpack_public_path__ + "static/media/as.00b45dd3.webp";